export function formatBRL(value: number){
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    value,
  );
}

export function isRs(origem: string, destino: string){
  const ufOrigem = getUf(origem);
  const UfDestino = getUf(destino);

  return ufOrigem === 'RS' && UfDestino === 'RS';
}

export function getUf(cidade: string){
  const value = cidade.trim().toUpperCase();

  if(value.length === 2){
    return value;
  }

  const [, uf = ''] = value.split('-');

  return uf.trim();
}
